import Handover from '../../views/pages/Handover';
import Logout from '../../views/pages/Logout';
import NotFound from '../../views/pages/NotFound';

export default [{
  path: '/account/logout',
  name: 'Account Logout',
  component: Logout,
}, {
  path: '/handover/:redirect',
  name: 'Handover',
  component: Handover,
}, {
  path: '*',
  name: 'Not Found',
  component: NotFound,
}];
